export const formatStationWorkingTimeDate = (value: Date | string): string => {
  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");

    // Use local calendar date to avoid UTC-driven off-by-one shifts.
    return `${year}-${month}-${day}`;
  }
  return String(value);
};
